<template>
  <div id="yamap" ref="target"></div>
</template>

<script setup>
import { loadJs } from "~/helpers/file";
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef } from "vue";
const target = useTemplateRef("target");
const isVisible = useElementVisibility(target);

import { inject } from "vue";
const data = inject("yaMap");
const started = ref();
//*
watch(isVisible, async (n) => {
  if (n && !started.value) {
    started.value = true;
    await loadJs("https://api-maps.yandex.ru/2.1/?lang=ru_RU", "yaMapJS");
    try {
      ymaps.ready(() => {
        const map = new ymaps.Map("yamap", {
          center: [data.x, data.y],
          zoom: data.zoom,
          controls: [
            "zoomControl",
            "fullscreenControl",
            "trafficControl",
            "typeSelector",
          ],
        });

        const myPlacemark = new ymaps.Placemark(
          [data.x, data.y],
          { hintContent: data.title, balloonContent: data.text },
          { preset: "islands#nightDotIcon" }
        );
        map.geoObjects.add(myPlacemark);
      });
    } catch (e) {
      console.error("Yandex Maps API failed to load", e);
    }
  }
});
//*/
</script>
